import { render, staticRenderFns } from "./ClienteTinySearch.vue?vue&type=template&id=45ce879e&"
import script from "./ClienteTinySearch.vue?vue&type=script&lang=js&"
export * from "./ClienteTinySearch.vue?vue&type=script&lang=js&"
import style0 from "./ClienteTinySearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports